import { render, staticRenderFns } from "./WeeklyThermalModuleProdutionSummary.vue?vue&type=template&id=5aa3b8bc"
import script from "./WeeklyThermalModuleProdutionSummary.vue?vue&type=script&lang=js"
export * from "./WeeklyThermalModuleProdutionSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports